require('./RAGoalSummary.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @commons
const RAOneLineSymbolAmount = require('../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const RAImageIcon = require('../commons/RAImageIcon/RAImageIcon');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
const {
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_MONTHLY,
    RA_ADDITIONAL_CONTRIBUTION_URL,
} = require('../../raConstants/index');
const { EURO_SYMBOL } = require('constants/index');

class RAGoalSummary extends React.Component {
    getRecurringContributionSummary(
        regularContributionsAmount,
        periodicity,
        showWithoutContributionText,
        contributionFailure,
    ) {
        let regularContributionsAmountObject;
        let periodicityLabel;
        if (
            regularContributionsAmount !== false &&
            periodicity !== false &&
            !contributionFailure
        ) {
            regularContributionsAmountObject = {
                amount: regularContributionsAmount,
                currency: EURO_SYMBOL,
            };
            switch (periodicity) {
                case CONTRIBUTION_PERIOD_DAILY:
                    periodicityLabel = 'raContributionPeriodicity-daily';
                    break;
                case CONTRIBUTION_PERIOD_WEEKLY:
                    periodicityLabel = 'raContributionPeriodicity-weekly';
                    break;
                case CONTRIBUTION_PERIOD_MONTHLY:
                    periodicityLabel = 'raContributionPeriodicity-monthly';
                    break;
            }
        } else {
            regularContributionsAmountObject = {
                amount: 0,
                currency: EURO_SYMBOL,
            };
            periodicityLabel = null;
        }
        const hasPeriodicityLabel = periodicityLabel ? (
            <div>
                <FormattedText
                    className="ra-goal-summary__gbi-box-info-sub-item-value"
                    value={periodicityLabel}
                />
            </div>
        ) : null;

        let periodicContributionElement = (
            <RAOneLineSymbolAmount
                className="ra-goal-summary__gbi-info-item-value"
                amountObject={regularContributionsAmountObject}
            />
        );
        if (
            showWithoutContributionText &&
            (!regularContributionsAmount || contributionFailure)
        ) {
            periodicContributionElement = (
                <FormattedText
                    className="ra-goal-summary__gbi-info-item-value"
                    value="raAssociateObjective-raAssociateObjective_noContributionText"
                />
            );
        }

        return (
            <div className="col-md-4 ra-goal-summary__gbi-box-wrapper">
                <div className="ra-goal-summary__gbi-box-info">
                    {periodicContributionElement}
                    <div>
                        <FormattedText
                            className="ra-goal-summary__gbi-box-info-sub-item-label"
                            value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_goalPeriodicalContributionLabel"
                        />
                    </div>
                    {hasPeriodicityLabel}
                </div>
            </div>
        );
    }

    buildPeriodicContributionRedirectLink() {
        return (
            <OKLink inverse={true} to={RA_ADDITIONAL_CONTRIBUTION_URL}>
                <FormattedText value="raAssociateObjective-raAssociateObjective_periodicContributionLinkText" />
            </OKLink>
        );
    }

    render() {
        const {
            iconType,
            goalName,
            goalEndOfDate,
            investmentAmount,
            goalAmount,
            regularContributionsAmount,
            showWithoutContributionText,
            contributionFailure,
            currentValuationLabel,
            periodicity,
        } = this.props;

        const formatedGoalEndOfDate = moment(goalEndOfDate)
            .format('DD-MMM-YYYY')
            .replace(new RegExp('-', 'gi'), ' ');
        const goalAmountObject = {
            amount: goalAmount,
            currency: EURO_SYMBOL,
        };
        const investmentAmountObject = {
            amount: investmentAmount,
            currency: EURO_SYMBOL,
        };
        const regularContributionSummary = this.getRecurringContributionSummary(
            regularContributionsAmount,
            periodicity,
            showWithoutContributionText,
            contributionFailure,
        );

        const contributionFailureMessage = contributionFailure && (
            <div className="row">
                <div className="col-xs-12 col-md-12 ra-goal-summary__contribution-failure-text">
                    <OKMessage type="informative">
                        <FormattedTextWithComponents
                            value="raAssociateObjective-raAssociateObjective_periodicContributionErrorMsg"
                            injectedComponents={[
                                this.buildPeriodicContributionRedirectLink(),
                            ]}
                        />
                    </OKMessage>
                </div>
            </div>
        );

        const investmentAmountText = !!currentValuationLabel
            ? currentValuationLabel
            : 'raHireManagementPlanSuccess-raHireManagementPlanSuccess_goalInvestmentLabel';

        //TODO: add array of key/clases to give the right background image to GBI icon
        return (
            <div className="row">
                <div className="col-md-4">
                    <div className="ra-goal-summary__gbi-info-wrapper">
                        <div className="ra-goal-summary__icon-container">
                            <RAImageIcon iconType={iconType.toLowerCase()} />
                        </div>
                        <div className="ra-goal-summary__gbi-info-container">
                            <div>
                                <span className="ra-goal-summary__gbi-name">
                                    {goalName}
                                </span>
                            </div>
                            <div>
                                <span className="ra-goal-summary__gbi-info-item-value__date">
                                    <i className="ra-goal-summary__red_flag icon-skyline" />
                                    {formatedGoalEndOfDate}
                                </span>
                            </div>
                            <div>
                                <FormattedText
                                    className="ra-goal-summary__gbi-box-info-sub-item-label"
                                    value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_goalEndOfDate"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-7 col-xs-offset-1">
                    <div className="row">
                        {regularContributionSummary}
                        <div className="col-md-4 ra-goal-summary__gbi-box-wrapper">
                            <div className="ra-goal-summary__gbi-box-info">
                                <RAOneLineSymbolAmount
                                    className="ra-goal-summary__gbi-info-item-value"
                                    amountObject={investmentAmountObject}
                                />
                                <div>
                                    <FormattedText
                                        className="ra-goal-summary__gbi-box-info-sub-item-label"
                                        value={investmentAmountText}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 ra-goal-summary__gbi-box-wrapper">
                            <div className="ra-goal-summary__gbi-box-info">
                                <RAOneLineSymbolAmount
                                    className="ra-goal-summary__gbi-info-item-value"
                                    amountObject={goalAmountObject}
                                />
                                <div>
                                    <FormattedText
                                        className="ra-goal-summary__gbi-box-info-sub-item-label"
                                        value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_goalAmountLabel"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {contributionFailureMessage}
                </div>
            </div>
        );
    }
}

RAGoalSummary.propTypes = {
    iconType: PropTypes.string.isRequired,
    goalName: PropTypes.string.isRequired,
    goalEndOfDate: PropTypes.string.isRequired,
    regularContributionSummary: PropTypes.string.isRequired,
    investmentAmount: PropTypes.string.isRequired,
    goalAmount: PropTypes.string.isRequired,
    regularContributionsAmount: PropTypes.string.isRequired,
    periodicity: PropTypes.number.isRequired,
    showWithoutContributionText: PropTypes.bool,
    contributionFailure: PropTypes.bool,
    currentValuationLabel: PropTypes.string,
};

RAGoalSummary.defaultProps = {
    showWithoutContributionText: false,
    contributionFailure: false,
};

module.exports = RAGoalSummary;
